// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__FE4mA","link__largeFont":"style_link__largeFont__SX8YG","link__highlight":"style_link__highlight__9HG_G","badge":"style_badge__CtBiQ"};